import { BatchCertificationFlag } from '@/Domain/Batch'

export class BatchCertifications {
  private _uneCertification: BatchCertificationFlag
  private _fscCertification: BatchCertificationFlag

  constructor (uneCertification: BatchCertificationFlag, fscCertification: BatchCertificationFlag) {
    this._uneCertification = uneCertification
    this._fscCertification = fscCertification
  }

  uneCertification (): boolean {
    return this._uneCertification.value()
  }

  fscCertification (): boolean {
    return this._fscCertification.value()
  }
}
